"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function parseAsFullyQualifiedURI(uri) {
    let origin = '';
    try {
        const urlObj = new URL(uri);
        origin = urlObj.origin;
        uri = urlObj.pathname + urlObj.search + urlObj.hash;
    }
    catch (_a) { }
    return { origin, uri };
}
exports.default = parseAsFullyQualifiedURI;
